<template>
	<div class="home">
		<!-- <h2 class="qjc-texta-c">订单统计</h2> -->
		<div class="charts_wrap">
			<div class="user_wrap">
				<div class="charts_title">最近一年订单数据统计</div>
				<div class="user_echarts"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts';
	import { getStatistics } from "@/utils/axios"
	
	export default{
		name: 'mainOrderCharts',
		data() {
			return {
				userInfo: {},
			}
		},
		mounted() {
			if(localStorage.getItem('userInfo')) {
				this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
				this.handleLoad()
			}
		},
		methods: {
			handleLoad() {
				getStatistics({act: 'order'}).then((res) => {
					if(res.code == 200) {
						let result = JSON.parse(window.atob(res.data))
						this.handleUserCharts(result.date, result.num, result.total_amount, result.total_cash_fee)
					}
				})
			},
			handleUserCharts(date, num, amount, cash) {
				var option = {
						tooltip: {
							trigger: 'axis',
							formatter: function (params) {
								if(params && params.length == 3) {
									return '月份：' + params[0].name + '<br>' + params[0].seriesName + '：' + params[0].value + '<br>' + params[1].seriesName + '：' + params[1].value + '<br>' + params[2].seriesName + '：' + params[2].value
								} else if(params && params.length == 2) {
									return '月份：' + params[0].name + '<br>' + params[0].seriesName + '：' + params[0].value + '<br>' + params[1].seriesName + '：' + params[1].value
								} else {
									return '月份：' + params[0].name + '<br>' + params[0].seriesName + '：' + params[0].value
								}
								
							}
						},
						legend: {
							show: true,
							data: ['订单数', '订单总金额', '订单实付金额'],
							icon: 'round',
							textStyle: {
								color: '#777F8F',
								fontSize: 12
							},
							top: 0,
							left: '45%',
							itemHeight: 2,
							itemWidth: 20,
							itemGap: 6,
							zlevel: 100,
						},
						grid: {
							left: '5%',
							right: '6%',
							bottom: '10%',
							top: '10%'
						},
						xAxis: {
							// boundaryGap: false,
							axisLabel: {
								color: '#777F8F',
								interval: 0
							},
							axisLine: {
								show: false
							},
							axisTick: {
								show: false
							},
							splitLine: {
								show: 'true',
								lineStyle: {
									color: '#f5f5f5'
								}
							},
							data: date
						},
						yAxis: {
							name: '',
							type: 'value',
							axisLabel: {
								color: '#777F8F'
							},
							minInterval: 1,
							max: function (value) {
							    return Math.ceil(value.max) + 50;
							},
							axisLine: {
								show: false
							},
							axisTick: {
								show: false
							},
							splitLine: {
								lineStyle: {
									color: '#f5f5f5'
								}
							}
						},
						series: [
							{
								type: 'line',
								name: '订单数',
								// smooth: true,
								data: num
							},
							{
								type: 'bar',
								name: '订单总金额',
								// smooth: true,
								barWidth: 30,
								data: amount
							},
							{
								type: 'line',
								name: '订单实付金额',
								// smooth: true,
								data: cash
							},
						],
						// yAxis:[
						// 	{
						// 		name: '',
						// 		type: 'value',
						// 		position: 'left',
						// 		axisLabel: {
						// 			color: '#777F8F',
						// 			formatter: '{value} 单'
						// 		},
						// 		minInterval: 1,
						// 		max: function (value) {
						// 			return Math.ceil(value.max) * 2;
						// 		},
						// 		axisLine: {
						// 			show: false
						// 		},
						// 		axisTick: {
						// 			show: false
						// 		},
						// 		splitLine: {
						// 			lineStyle: {
						// 				color: '#f5f5f5'
						// 			}
						// 		}
						// 	},
						// 	{
						// 		name: '',
						// 		type: 'value',
						// 		axisLabel: {
						// 			color: '#777F8F',
						// 			formatter: '{value} 元'
						// 		},
						// 		position: 'right',
						// 		minInterval: 1,
						// 		max: function (value) {
						// 			return Math.ceil(value.max) + 1000;
						// 		},
						// 		axisLine: {
						// 			show: false
						// 		},
						// 		axisTick: {
						// 			show: false
						// 		},
						// 		splitLine: {
						// 			lineStyle: {
						// 				color: '#f5f5f5'
						// 			}
						// 		}
						// 	},
						// ],
						// series: [
						// 	{
						// 		type: 'line',
						// 		name: '订单数',
						// 		smooth: true,
						// 		yAxisIndex: 0,
						// 		data: num
						// 	},
						// 	{
						// 		type: 'line',
						// 		name: '订单总金额',
						// 		smooth: true,
						// 		barWidth: 30,
						// 		yAxisIndex: 1,
						// 		data: amount
						// 	},
						// 	{
						// 		type: 'line',
						// 		name: '订单实付金额',
						// 		smooth: true,
						// 		yAxisIndex: 1,
						// 		data: cash
						// 	},
						// ],
						color: ['#e86140' ,'#6883FB','#65D448']
					};
				this.drawChat('.user_echarts', option);
			},
			
			drawChat(el, option){
				window[el] = echarts.init(document.querySelector(el));
				// option.animationDuration = 1000;
				window[el].setOption(option,true);
				window.onresize = window[el].resize;
			},// 绘制图表通用
		},
	}
</script>

<style lang="scss" scoped>
	
	.home {
		padding: 30px 40px;
	}
	.home-wrap {
		padding: 40px;
		// border-bottom: 1px solid #dddddd;
	}
	.home-cell {
		font-size: 15px;
		margin-bottom: 10px;
		span {
			margin-right: 20px;
		}
	}
	.home-bottom {
		text-align: center;
		margin-top: 40px;
		font-size: 12px;
		padding-top: 20px;
		border-top: 1px solid #dddddd;
	}
	
	.charts_wrap {
		
	}
	.charts_title {
		font-size: 20px;
		color: #333;
	}
	.user_echarts {
		width: 100%;
		height: 450px;
		margin-bottom: 40px;
	}
	.order_echarts {
		width: 100%;
		height: 450px;
	}
</style>
